import { MunicipalPropertyRegisterListInput } from "@/graphql/generated/graphql";
import { MUNICIPAL_PROPERTY_LIST_PAGE_SIZE } from "@ark/shared";

import { MunicipalPropertyRegisterFilter } from "./municipal-property-register-filter.model";

interface ToMunicipalPropertyRegisterListInputOptions {
  workspaceId: string;
  filter: MunicipalPropertyRegisterFilter;
  after?: string;
}

export function toMunicipalPropertyRegisterListInput({
  workspaceId,
  filter,
  after,
}: ToMunicipalPropertyRegisterListInputOptions): MunicipalPropertyRegisterListInput {
  return {
    workspaceId,
    first: MUNICIPAL_PROPERTY_LIST_PAGE_SIZE.default,
    after: after ?? null,
    year: filter.year,
    search: filter.search?.trim() || null,
  };
}
